import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_nav_dock_horizontal_select';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default off: tap/click only until the experiment is enabled in Dev Tools.
		if (stored === null) return false;
		return stored === 'true';
	} catch {
		return false;
	}
};

/**
 * When true, drag-to-scrub / horizontal wheel on the PillShapedDock moves selection.
 * Preference is saved locally.
 */
export const navDockHorizontalSelectEnabled = writable<boolean>(readInitialValue());

navDockHorizontalSelectEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isNavDockHorizontalSelectEnabled = (): boolean => get(navDockHorizontalSelectEnabled);

export const setNavDockHorizontalSelectEnabled = (enabled: boolean) => {
	navDockHorizontalSelectEnabled.set(enabled);
};
